import { HttpMethods, makeRequest } from "../helpers/http.helper";
import {
  AdminCreateUserRequest,
  LoginRequest,
  RegisterRequest,
  RefreshTokenRequest,
  UpdateUserRequest,
} from "../types/auth.type";

export const loginUser = (data: LoginRequest) =>
  makeRequest({
    url: "/user/login",
    method: HttpMethods.POST,
    data,
  });

export const registerUser = (data: RegisterRequest) =>
  makeRequest({
    url: "/user/register",
    method: HttpMethods.POST,
    data,
  });

export const adminCreateUser = (data: AdminCreateUserRequest) =>
  makeRequest({
    url: "/user/admin/create",
    method: HttpMethods.POST,
    data,
  });

export const refreshToken = (data: RefreshTokenRequest) =>
  makeRequest({
    url: "/user/refresh-token",
    method: HttpMethods.POST,
    data,
  });

export const getUsers = () =>
  makeRequest({
    url: "/user/",
    method: HttpMethods.GET,
  });

export const updateUser = (userId: string, data: UpdateUserRequest) =>
  makeRequest({
    url: `/user/${userId}`,
    method: HttpMethods.PUT,
    data,
  });

export const deleteUser = (userId: string) =>
  makeRequest({
    url: `/user/${userId}`,
    method: HttpMethods.DELETE,
  });
